import { lazyWithRetry } from "utils/lazy-with-retry";
import { ICreateEditAssignmentGroupProps } from "./definitions";

const LazyCreateEditAssignmentGroup = lazyWithRetry(
  () => import("./CreateEditAssignmentGroup"),
);

const CreateEditAssignmentGroup = (
  props: JSX.IntrinsicAttributes & ICreateEditAssignmentGroupProps,
) => <LazyCreateEditAssignmentGroup {...props} />;

export default CreateEditAssignmentGroup;
